var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeIcon = function SvgYoutubeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#E0302C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3437 10.8736C23.1479 10.1373 22.5684 9.55636 21.8312 9.35727C20.4983 9 15.1501 9 15.1501 9C15.1501 9 9.80465 9 8.46896 9.35727C7.73448 9.55364 7.15505 10.1345 6.95646 10.8736C6.6001 12.21 6.6001 15 6.6001 15C6.6001 15 6.6001 17.79 6.95646 19.1264C7.15232 19.8627 7.73176 20.4436 8.46896 20.6427C9.80465 21 15.1501 21 15.1501 21C15.1501 21 20.4983 21 21.8312 20.6427C22.5657 20.4464 23.1452 19.8655 23.3437 19.1264C23.7001 17.79 23.7001 15 23.7001 15C23.7001 15 23.7001 12.21 23.3437 10.8736Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4417 17.5718L17.884 15L13.4417 12.4282V17.5718Z",
    fill: "#E0302C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Youtube-icon.e802449b.svg";
export { ForwardRef as ReactComponent };